<svg [attr.width]="width" [attr.height]="height" [attr.viewBox]="'0 0 ' + width + ' ' + height">
  <circle [attr.cx]="centerX"
          [attr.cy]="centerY"
          [attr.r]="radius"
          [attr.stroke-width]="strokeWidth"
          fill="none"
          stroke="#C0DAEA"
  />
  <circle [attr.cx]="centerX"
          [attr.cy]="centerY"
          [attr.r]="radius"
          [attr.stroke-dasharray]="circumference"
          [attr.stroke-dashoffset]="(progress >= 100 ? 0 : circumference - progress / 100 * circumference)"
          [attr.stroke-width]="strokeWidth"
          [attr.transform]="'rotate(-90 ' + centerX + ' ' + centerY + ')'"
          fill="none"
          stroke="#007BC0"
          stroke-linecap="round"
  />

  <text [attr.x]="centerX"
        [attr.y]="centerY - strokeWidth"
        [style.font-size.px]="fontSizeText"
        text-anchor="middle"
        fill="#71767C"
        class="progress-text"
  >
    {{ text }}
  </text>
  <text [attr.x]="centerX"
        [attr.y]="centerY + strokeWidth"
        [style.font-size.px]="fontSizeValue"
        text-anchor="middle"
        fill="#1F1F1F"
        class="progress-text"
  >
    {{ progress?.toFixed(2) }}%
  </text>
</svg>
